import React, { PureComponent, Fragment } from 'react';

import data from '~/assets/data/turnout.csv';
import StaticMap from '~/kits/general/scripts/components/StaticMap';
import withSlide from '~/kits/general/scripts/components/withSlide';
import { getColorScale } from '~/kits/general/scripts/components/ComparisonMap/utils';
import Legend from '~/core/scripts/components/Legend';

import './TurnoutMap.styl';

const mapData = data.map(d => ({ key: d.country, value: d.right }));

const colorScale = getColorScale([
  [5, '#d3d3d3'],
  [10, '#a2a2a2'],
  [15, '#757575'],
  [20, '#494949'],
  [30, '#222222']
]);

const maxLegendValue = 0;

class TurnoutMap extends PureComponent {
  render() {
    const { title, text } = this.props;

    return (
      <Fragment>
        <div className="slide-title">{title}</div>
        <div className="slide-text">{text}</div>
        <div className="turnout-map-wrapper">
          <StaticMap
            data={mapData}
            colorScale={colorScale}
            maxLegendValue={maxLegendValue}
            swoopies={[
              {
                lat: 57.6741958,
                lng: 1.9995703,
                text: 'Brexit Partei (29 Sitze)',
                style: { transform: 'translate(-100%, -100%)' },
                iconStyle: { transform: 'scaleX(-1)', 'left': '40px' } }
            ]}
          />
        </div>
        <Legend
          maxLabel={`${colorScale.values[4]} ` || 'max'}
          minLabel={`${maxLegendValue} ` || 'min'}
          colors={colorScale.colors}
        />
      </Fragment>
    );
  }
}

export default withSlide(TurnoutMap);
